import httpClient from '../../httpClient';

/**
 * 회원가입 이메일 인증코드 검증
 * @typedef {Object} obj
 * @param {string} email - user email
 * @param {string} authCode - email auth Code
 */
function signupEmailAuthCodeVerify({ email, authCode }) {
  return httpClient({
    url: '/auth/signup/email/verify',
    method: 'POST',
    data: {
      email,
      authCode,
    },
  });
}

export default signupEmailAuthCodeVerify;
